export default __webpack_public_path__ + "img/c3c65bb25c6a27ffcd33fa984b93ac16.png";